<template>
    <div>
        <!-- Desktop -->
        <div class="dead-end-container show-for-large" :style="'background-image: url(' + backgroundTextureUrl + ')'">
            <div class="align-middle grid-x grid-padding-x grid-margin-x page-not-found-container">
                <div class="cell shrink">
                    <img src="/media/static/svg/dead_end_fg.svg" al t="Dead End Background Foreground Layer" class="svg-closed">
                </div>
                <div class="cell auto xxlarge-offset-1 color-text">
                    <slot/>
                </div>
            </div>
            <img v-for="(foregroundImg, i) in foregroundImages" :key="i" :src="foregroundImg.url" :style="foregroundImg.style" class="foreGroundImg" alt="Foreground image">
        </div>
        <!-- Mobile / Tablet -->
        <div class="dead-end-container hide-for-large" :style="'background-image: url(' + backgroundTextureUrl + ')'">
            <div class="grid-x grid-padding-x align-center-middle page-not-found-container">
                <div class="text-center cell large-5 color-text">
                    <slot/>
                </div>
            </div>
            <div class="dead-end-logo hide-for-large">
                <img :src="storeLogo" alt="Store Logo">
            </div>
            <div class="image-background hide-for-large layer-bg">
                <img src="/media/static/svg/dead_end_bg.svg" alt="Dead End Background">
            </div>
            <div class="text-center image-background hide-for-large layer-fg">
                <img src="/media/static/svg/dead_end_fg.svg" alt="Dead End Background Foreground Layer">
            </div>
            <div class="hide-for-large background-gradient"></div>
        </div>
    </div>


</template>
<script lang="ts">
import Settings, { SettingNamespace } from '@/utils/settings';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class DeadEndLayout extends Vue
{
    storeLogo: string = '';

    async created() {
        const settings = await Settings.getInstance();
        this.storeLogo = settings.get(SettingNamespace.GENERAL, 'store_logo')?.value;
    }

    get foregroundImages() {
        return (<any>window).foregroundImages || [];
    }

    get backgroundTextureUrl() {
        return (<any>window).deadEndbackgroundTextureUrl || '';
    }
}
</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.dead-end-container {
    background-color: var(--dead-end-mobile-bg);
    background-size: cover;
    @include breakpoint(medium down) {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 30px 30px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
    }

    .page-not-found-container {
        @include breakpoint(medium down) {
            position: relative;
            bottom: 75px;
        }

        @include breakpoint(large) {
            height: calc(100vh);
            max-width: 1440px;
            margin: auto;
        }
    }
}




//Desktop
.svg-closed {

    position: relative;
    z-index: 1;

    @include breakpoint (large) {
        width: 450px;
    }

    @include breakpoint(xlarge) {
        width: 650px;
    }
}

.foreGroundImg {
    position: absolute;
    z-index: 0;
}

//Mobile
.dead-end-logo {
    position: absolute;
    top: 20px;
    width: 30vw;
}

.image-background {
    position: absolute;

    &.layer-fg {
        z-index: -1;
    }

    &.layer-bg {
        z-index: -3;
    }
}

.background-gradient {
    background: var(--dead-end-bg-overlay);
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom:0;
    z-index: -2;
}

.color-text {
    @include breakpoint(medium down) {
        color: var(--white);
    }
}
</style>
